import React from "react";

const Backend = () => {
	return (
		<div className='skills__content'>
			<h3 className='skills__title'>Back-End</h3>

			<div className='skills__box'>
				<div className='skills__group'>
					<div className='skills__data'>
						<i class='bx bx-badge-check'></i>
						<div>
							<h3 className='skills__name'>DataGrip</h3>
							<span className='skills__level'>Advanced</span>
						</div>
					</div>
					<div className='skills__data'>
						<i class='bx bx-badge-check'></i>
						<div>
							<h3 className='skills__name'>NodeJS</h3>
							<span className='skills__level'>Advanced</span>
						</div>
					</div>
					<div className='skills__data'>
						<i class='bx bx-badge-check'></i>
						<div>
							<h3 className='skills__name'>Python</h3>
							<span className='skills__level'>Intermediate</span>
						</div>
					</div>
				</div>

				<div className='skills__group'>
					<div className='skills__data'>
						<i class='bx bx-badge-check'></i>
						<div>
							<h3 className='skills__name'>SQLite3</h3>
							<span className='skills__level'>Intermediate</span>
						</div>
					</div>
					<div className='skills__data'>
						<i class='bx bx-badge-check'></i>
						<div>
							<h3 className='skills__name'>Firebase</h3>
							<span className='skills__level'>Intermediate</span>
						</div>
					</div>
					<div className='skills__data'>
						<i class='bx bx-badge-check'></i>
						<div>
							<h3 className='skills__name'>ExpressJS</h3>
							<span className='skills__level'>Intermediate</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Backend;
